module.exports = __webpack_public_path__ + "img/ttf-main-414.4078ee79.jpg";